// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';
import $ from "jquery";

// IMPORT COMPONENTS
import moduleBackgroundImage from "@core/components/module-background-image/module-background-image";
import Pattern from '@pj/components/pattern/pattern';

const bannerArticle=new BaseModule();
bannerArticle.name='banner-article';
bannerArticle.init(that=> {
  moduleBackgroundImage(that.elements);

  const pattern=new Pattern();
  pattern.init(that.elements);
});

